export const isDateLikeValue = (value: unknown): boolean => {
  if (typeof value !== "string" || !value) return false;
  if (!/^\d{4}-\d{2}-\d{2}/.test(value)) return false;
  return !Number.isNaN(Date.parse(value));
};

export const formatAuditCellValue = (
  value: unknown,
  isDateColumn: boolean,
): string => {
  if (value === null || value === undefined || value === "") return "-";

  if (isDateColumn || isDateLikeValue(value)) {
    const parsed = new Date(value as string);
    if (!Number.isNaN(parsed.getTime())) {
      return parsed.toLocaleString();
    }
  }

  return String(value);
};

export const getDefaultFilters = (
  columns: { columnName: string; isFilterable: boolean }[],
): Record<string, string> =>
  columns
    .filter((column) => column.isFilterable)
    .reduce<Record<string, string>>((acc, column) => {
      acc[column.columnName] = "";
      return acc;
    }, {});
